// Dev-only error surface to catch the “process is not defined” culprit.
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const logError = (prefix, evt, extra = {}) => {
    // Avoid crashing if console is unavailable
    if (!console || !console.error) return;
    const payload = {
      prefix,
      message: evt?.message || evt?.reason?.message || String(evt?.reason || evt),
      filename: evt?.filename || evt?.reason?.fileName || extra.filename,
      lineno: evt?.lineno || extra.lineno,
      colno: evt?.colno || extra.colno,
      stack:
        (evt?.error && evt.error.stack) ||
        (evt?.reason && evt.reason.stack) ||
        extra.stack,
    };
    console.error('[dev-error-capture]', payload);
  };

  window.addEventListener('error', (evt) => {
    logError('window.onerror', evt, {
      filename: evt?.filename,
      lineno: evt?.lineno,
      colno: evt?.colno,
      stack: evt?.error?.stack,
    });
  });

  window.addEventListener('unhandledrejection', (evt) => {
    logError('window.onunhandledrejection', evt, {
      filename: evt?.reason?.fileName,
      stack: evt?.reason?.stack,
    });
  });
}
